import { IsNullOrEmptyHtml } from "helpers/stringHelper";
import { useCurrentCompany } from "hooks/auth";
import React from "react";

import { AdditionalMessageDisplay } from "./components/AdditionalMessageDisplay";
import { ButtonLink } from "./components/ButtonLink";
import { RFxMailLayout } from "./components/RFxMailLayout";
import type { EmailContentForOnboardingProps } from "./types/EmailContent.interface";

export const InviteForPreApprovalEmailContent: React.FC<
	EmailContentForOnboardingProps
> = ({ isOnboarding, rfxMail }) => {
	const emailData = rfxMail?.emailData;
	const currentCompany = useCurrentCompany();

	if (!emailData) {
		return null;
	}

	const $additional_message = emailData?.additional_message;
	const type_project =
		rfxMail?.rfx_type_name_project_name(" -") ?? "[RFX Project Name]";
	const hasAdditionalText = !IsNullOrEmptyHtml($additional_message);
	const supplier_contact_name = "[First Name Last Name], (Guest Name) ";

	return (
		<RFxMailLayout
			$supplier_contact_name={supplier_contact_name}
			$contact={emailData?.contact}
			rfx_type={emailData?.rfx_code}
			project_name={emailData?.project_name}
			rfx_title={emailData?.rfx_title}
			isOnboarding={isOnboarding}
		>
			<tr>
				<td
					style={{
						fontFamily: "Arial, sans-serif",
						fontSize: "16px",
						lineHeight: "24px",
						color: "#374151",
						paddingBottom: "20px",
					}}
				>
					A request for approval has been submitted on Procuracon for
					{isOnboarding ? (
						" an Onboarding and Pre-qualification request being sent to suppliers."
					) : (
						<>
							<br />
							<b>{type_project}</b>.
						</>
					)}
					<br />
					<br />
					This request has been submitted by:
					<br />
					<b>
						{emailData?.contact.contact_name}, {currentCompany.name}
					</b>
					<br />
				</td>
			</tr>
			{hasAdditionalText && (
				<tr>
					<td
						style={{
							fontFamily: "Arial, sans-serif",
							fontSize: "16px",
							lineHeight: "24px",
							color: "#374151",
						}}
					>
						The additional comments from {emailData?.contact.contact_name} are:
					</td>
				</tr>
			)}
			<AdditionalMessageDisplay
				additional_message={$additional_message}
				className="italic"
			/>
			<tr>
				<td
					style={{
						fontFamily: "Arial, sans-serif",
						fontSize: "16px",
						lineHeight: "24px",
						color: "#374151",
						paddingBottom: "40px",
					}}
				>
					To review and provide your approval, please click the button below to
					set up and access your guest account.
					<br />
				</td>
			</tr>
			<tr>
				<ButtonLink />
			</tr>
			<tr>
				<td
					style={{
						fontFamily: "Arial, sans-serif",
						fontSize: "16px",
						lineHeight: "24px",
						color: "#374151",
					}}
				>
					<br />
					<br />
					If you have any questions, please do not hesitate to contact me using
					the details below.
				</td>
			</tr>
		</RFxMailLayout>
	);
};
